import React, { FC, useState } from "react";

import WelcomeBanner from "@components/common/WelcomeBanner";
import { Grid } from "@components/base";
import { CustomColors } from "@type/CustomPalette";
import { WelcomeBannerProps } from "@components/common/WelcomeBanner/WelcomeBanner";

interface WelcomeBannerContainerProps {
  title: string;
  text: string;
  color: string;
  icon: string;
}

const WelcomeBannerContainer: FC<WelcomeBannerContainerProps> = ({
  title,
  text,
  color = "blue",
  icon = "accountant",
}) => {
  const [show, setShow] = useState(true);

  const onClose = (): void => {
    setShow(false);
  };

  return show ? (
    <Grid size={12}>
      <WelcomeBanner
        color={color as CustomColors}
        title={title}
        text={text}
        icon={icon as WelcomeBannerProps["icon"]}
        onClose={onClose}
      />
    </Grid>
  ) : null;
};

export default WelcomeBannerContainer;
